import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import ProductCardNew from "../../ProductCard/ProductCardNew";

import "swiper/css";
import "swiper/css/navigation";
import "./RelatedProducts.css";

export default function RelatedProducts({
    products = [],
    currentProductId,
}) {
    const filteredProducts = products.filter(
        (product) => product.id !== currentProductId
    );

    if (filteredProducts.length === 0) return null;

    return (
        <section className="related-products-section">
            <div className="related-products-header">
                <h2>محصولات مرتبط</h2>
            </div>

            <Swiper
                modules={[Navigation]}
                navigation
                spaceBetween={8}
                slidesPerView={1.2}
                watchOverflow={true}
                resistance={false}
                resistanceRatio={0}
                breakpoints={{
                    480: {
                        slidesPerView:1.2,
                    },

                    768: {
                        slidesPerView: 4,
                    },

                    1200: {
                        slidesPerView: 5,
                    },
                }}
                className="related-products-swiper"
            >


                {filteredProducts.map((product) => (
                    <SwiperSlide key={product.id}>
                        <ProductCardNew product={product} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
